// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions[data-v-5d48c100] {\n  display: flex;\n  gap: 10px;\n}", ""]);
// Exports
module.exports = exports;
